+function ($) {
    'use strict';

    var sb_resize = function () {
        this.before_resize && (this.before_resize)();

        var previous_page_width = this.page_width;
        this.page_width = document.documentElement.clientWidth;

        if ((
            this.window_max_width &&
            previous_page_width >= this.window_max_width &&
            this.page_width >= this.window_max_width
        ) || (
            this.window_min_width &&
            previous_page_width <= this.window_min_width &&
            this.page_width <= this.window_min_width
        )) {
            return; /* nothing to do */
        }

        this.top_boundary = Math.floor(this.top_element.offset().top - this.offset - this._padding_top);
        this.bottom_boundary = Math.floor(this.bottom_element.offset().top - this.offset - this._padding_bottom);

        var active =
            (!this.window_max_width || (this.page_width < this.window_max_width)) &&
            (!this.window_min_width || (this.page_width > this.window_min_width));

        !this.active && active && this.boundary_enabling && (this.boundary_enabling)();

        if (active && this.scroll >= this.bottom_boundary) {
            if (this.intersection !== 1) {
                this.boundary_below && (this.boundary_below)();
                this.intersection = 1;
            }
        } else if (active && this.scroll >= this.top_boundary) {
            if (this.intersection !== 0) {
                this.boundary_inside && (this.boundary_inside)();
                this.intersection = 0;
            }
        } else {
            if (active) {
                if (this.intersection !== -1) {
                    this.intersection = -1;
                    this.boundary_above && (this.boundary_above)();
                }
            } else {
                this.active = 0;
                this.intersection = false;
                this.boundary_disabling && (this.boundary_disabling)();
            }
        }

        this.active = active;
    };
    var sb_scroll = function () {
        var previous_scroll = this.scroll;
        this.scroll =
            window.pageYOffset || window.scrollY || /* synonymous in most browsers */
            document.documentElement.scrollTop ||
            document.body.scrollTop;

        if (!this.active) {
            return; /* nothing to do */
        }

        if (
            (this.scroll >= this.bottom_boundary) !==
            (previous_scroll >= this.bottom_boundary)
        ) {
            if (this.scroll >= this.bottom_boundary) {
                if (this.intersection !== 1) {
                    this.boundary_below && (this.boundary_below)();
                    this.intersection = 1;
                }
            } else {
                if (this.intersection !== 0) {
                    this.boundary_inside && (this.boundary_inside)();
                    this.intersection = 0;
                }
            }
        }
        if (
            (this.scroll >= this.top_boundary) !==
            (previous_scroll >= this.top_boundary)
        ) {
            if (this.scroll >= this.top_boundary) {
                if (this.intersection !== 0) {
                    this.boundary_inside && (this.boundary_inside)();
                    this.intersection = 0;
                }
            } else {
                if (this.intersection !== -1) {
                    this.boundary_above && (this.boundary_above)();
                    this.intersection = -1;
                }
            }
        }
    };

// debounce function adapted from underscore:
// https://davidwalsh.name/javascript-debounce-function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
    var sb_debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    var Scrollbox = function (args) {
        if (args.top_element == null) {
            throw new Error('top_element cannot be null');
        }
        this.top_element = $(args.top_element);
        if (!this.top_element.length) {
            throw new Error('top_element selector cannot be empty');
        }

        if (args.bottom_element == null) {
            throw new Error('bottom_element cannot be null');
        }
        this.bottom_element = $(args.bottom_element);
        if (!this.bottom_element.length) {
            throw new Error('bottom_element selector cannot be empty');
        }

        this.offset = parseInt(args.offset) || 0;
        this.padding = args.padding;

        /* compat: ie >= 9 (Array.isArray) */
        var isarr = Array.isArray(args.padding);
        this._padding_top = isarr && args.padding[0] != null
            ? parseInt(args.padding[0]) || 0
            : 0;
        this._padding_bottom = isarr && args.padding[1] != null
            ? parseInt(args.padding[1]) || 0
            : 0;

        this.window_min_width = parseInt(args.window_min_width) || 0;
        this.window_max_width = parseInt(args.window_max_width) || 0;

        this.boundary_above = typeof args.boundary_above === 'function'
            ? args.boundary_above
            : 0;
        this.boundary_inside = typeof args.boundary_inside === 'function'
            ? args.boundary_inside
            : 0;
        this.boundary_below = typeof args.boundary_below === 'function'
            ? args.boundary_below
            : 0;

        this.before_resize = typeof args.before_resize === 'function'
            ? args.before_resize
            : 0;
        this.boundary_disabling = typeof args.boundary_disabling === 'function'
            ? args.boundary_disabling
            : 0;
        this.boundary_enabling = typeof args.boundary_enabling === 'function'
            ? args.boundary_enabling
            : 0;


        this.intersection = -1; /* -1,0,1 above,inside,below */
        this.active = 0; /* boolean */

        this.scroll =
            window.pageYOffset || window.scrollY || /* synonymous in most browsers */
            document.documentElement.scrollTop ||
            document.body.scrollTop;
        this.page_width = document.documentElement.clientWidth;
        this.top_boundary = Math.floor(this.top_element.offset().top - this.offset - this._padding_top);
        this.bottom_boundary = Math.floor(this.bottom_element.offset().top - this.offset - this._padding_bottom);

        var active =
            (!this.window_max_width || this.page_width < this.window_max_width) &&
            (!this.window_min_width || this.page_width > this.window_min_width);

        !this.active && active && this.boundary_enabling && (this.boundary_enabling)();

        if (active && this.scroll >= this.bottom_boundary) {
            if (this.intersection !== 1) {
                this.boundary_below && (this.boundary_below)();
                this.intersection = 1;
            }
        } else if (active && this.scroll >= this.top_boundary) {
            if (this.intersection !== 0) {
                this.boundary_inside && (this.boundary_inside)();
                this.intersection = 0;
            }
        } else {
            if (active) {
                if (this.intersection !== -1) {
                    this.intersection = -1;
                    this.boundary_above && (this.boundary_above)();
                }
            } else {
                this.active = 0;
                this.intersection = false;
                this.boundary_disabling && (this.boundary_disabling)();
            }
        }

        this.active = active;

        this._sb_resize = sb_debounce(sb_resize.bind(this));
        this._sb_scroll = sb_scroll.bind(this);
        window.addEventListener('resize', this._sb_resize, false);
        window.addEventListener('scroll', this._sb_scroll, false);
    };
    Scrollbox.prototype = {
        destroy: function () {
            window.removeEventListener('resize', this._sb_resize, false);
            window.removeEventListener('scroll', this._sb_scroll, false);
        },
    };
    Scrollbox._debounce = sb_debounce;

    window.Scrollbox = Scrollbox;
}(window.jQuery);